<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="center">
      <div class="leftPane">
        <div class="topRight">
          <img src="assets/Vector-Top.svg" alt="" style="width: 100%;">
        </div>
        <div style="margin-top: 100px;margin-bottom: 51px;">
          <div style="padding: 25px 10px;;background: #631d4f;border:solid 1px #c4a7bb">
            <img class="logo" src="assets/SmartTruck-Logo-HalfWhite.svg" alt="">
          </div>
          <div style="text-align: right;padding: 20px;">
            <span class="signUp">
              {{'SIGNUP.signUp' | translate}}
            </span>
          </div>
        </div>
        <div class="bottomLeft">
          <img src="assets/Vector-Bottom.svg" alt="" srcset="" style="width: 50%;">
        </div>
      </div>

      <div class="rightpane">
        <div class="carrier-section">
          <div class="left">
            <div class="help_video" (click)="openAddVehicleVideoLink()">
              <span>{{'SIGNUP.help_video' | translate}}</span>
            </div>
            <div class="form">
              <div class="input">
                <span class="labels">{{'SIGNUP.enterprise' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.name" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.address' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.location.area" id="addressSearch" class="form-input" (keyup)="checkAddress()"
                  required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.locality' | translate}}</span><input type="text" class="form-input"
                  [(ngModel)]="signUpData.location.locality" />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.city' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
                </span><input type="text" class="form-input" [(ngModel)]="signUpData.location.city"
                  (keyup)="checkAddress()" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.country_code' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span>
                <mat-select class='form-input' [(ngModel)]="selectedCountry">
                  <mat-option *ngFor="let country of countries"
                    (onSelectionChange)="selectCountry(country);checkAddress()" [value]="country">
                    {{country.name}}
                  </mat-option>
                </mat-select>
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.pincode' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup></span><input type="text"
                  [(ngModel)]="signUpData.location.pincode" (keyup)="checkAddress()" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.phoneNo' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.location.mobile" class="form-input" required />
              </div>
              <!-- <div class="input">
                    <span class="labels">Documents </span><input type="file" class="form-input" required multiple (change)="onFileSelect();"/>
                  </div> -->
              <div class="input">
                <span class="labels" style="float: left; margin-left: 24px;">{{'SIGNUP.exemptTax' | translate}} </span>
                <mat-slide-toggle style="float: left; margin-left: 10px;" [(ngModel)]='signUpData.is_tax_exempted'
                  (change)="showTaxInput = signUpData.is_tax_exempted; signUpData.tax_number = ''"></mat-slide-toggle>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="form">
              <div class="input">
                <span class="labels">{{'SIGNUP.unitName' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.unit_name" class="form-input" />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.address' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input [disabled]="sameLocFlag" type="text"
                  [(ngModel)]="signUpData.unitLocation.area" id="addressSearchUnit" class="form-input" required />
                <div class="check">
                  <mat-checkbox [(ngModel)]="sameLocFlag" [disabled]="disableCheckbox" (change)='sameLoc(sameLocFlag)'>
                    {{'SIGNUP.unitAddress' | translate}}</mat-checkbox>
                </div>
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.locality' | translate}}</span><input [disabled]="sameLocFlag" type="text"
                  class="form-input" [(ngModel)]="signUpData.unitLocation.locality" />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.city' | translate}}<sup style="color: #E54131; font-weight: 900;">*</sup>
                </span><input [disabled]="sameLocFlag" type="text" class="form-input"
                  [(ngModel)]="signUpData.unitLocation.city" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.country_code' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span>
                <mat-select class='form-input' [(ngModel)]="selectedUnitCountry" [disabled]="sameLocFlag">
                  <mat-option *ngFor="let country of countries" (onSelectionChange)="selectUnitCountry(country)"
                    [value]="country">
                    {{country.name}}
                  </mat-option>
                </mat-select>
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.pincode' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input [disabled]="sameLocFlag" type="text"
                  [(ngModel)]="signUpData.unitLocation.pincode" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.phoneNo' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.unitLocation.mobile" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels" style="margin-left: 0px;">{{'SIGNUP.vehType' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup></span>
                <mat-select multiple>
                  <mat-option *ngFor="let vehicle of vehicles" (onSelectionChange)="selectvehicle(vehicle, $event)"
                    [value]="vehicle">
                    {{vehicle.name}}
                  </mat-option>
                </mat-select>
              </div>
              <div class="input" [hidden]="showTaxInput">
                <span class="labels">{{'SIGNUP.taxNumber' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.tax_number" class="form-input" />
              </div>
            </div>
          </div>
        </div>
        <div class="account">
          <span style="margin-left: 35px;color:#73235c;">
            {{'SIGNUP.accountDetails' | translate}}
          </span>
        </div>
        <div class="down"></div>
        <div class="user-section">
          <div class="left">
            <div class="form">
              <div class="input">
                <span class="labels">{{'SIGNUP.userName' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.user.name" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.email' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.user.email_id" class="form-input" required />
              </div>
              <div class="input">
                <span class="labels">{{'SIGNUP.mobile' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="text"
                  [(ngModel)]="signUpData.user.mobile" autocomplete="false" class="form-input" required />
              </div>
              <div class="truck" style="position: absolute">
                <img src="assets/Truck.svg" alt="" style="position: relative;right: calc(8% - 16px);width: 200px;" />
              </div>
            </div>
          </div>
          <div class="right">
            <div class="form">
              <div class="input" [ngStyle]="{'height': passwordStrengthPassedCheck.overall?'55px':'110px'}">
                <sup style="color: #E54131; font-weight: 900;">*</sup><span class="labels">{{'SIGNUP.password' |
                  translate}} </span>
                <input type="password" [(ngModel)]="signUpData.user.password" autocomplete="new-password"
                  class="form-input" (keyup)="passwordStrengthChecker()" required />
                <div class="passwordStrength">
                  <password-strength-meter [password]="signUpData.user.password"></password-strength-meter>
                </div>

                <ul class="passwordWarnings" *ngIf="!passwordStrengthPassedCheck.overall">
                  <li [hidden]="passwordStrengthPassedCheck.minimumChars">{{'SIGNUP.minimumChar' | translate}}</li>
                  <li [hidden]="passwordStrengthPassedCheck.oneSpecial">{{'SIGNUP.specialChar' | translate}}</li>
                  <li [hidden]="passwordStrengthPassedCheck.oneNumeric">{{'SIGNUP.oneNum' | translate}}</li>
                  <li [hidden]="passwordStrengthPassedCheck.oneCapital">{{'SIGNUP.capitalChar' | translate}}</li>
                  <li [hidden]="passwordStrengthPassedCheck.oneSmall">{{'SIGNUP.smallChar' | translate}}</li>
                </ul>
              </div>
              <div class="input" [hidden]="!passwordStrengthPassedCheck.overall">
                <sup style="color: #E54131; font-weight: 900;">*</sup><span class="labels">{{'SIGNUP.confirmPassword' |
                  translate}} </span><input type="password" [(ngModel)]="signUpData.user.confirmPassword"
                  class="form-input" required />
              </div>
              <div class="input" [hidden]=true>
                <span class="labels">{{'SIGNUP.inviteCode' | translate}}<sup
                    style="color: #E54131; font-weight: 900;">*</sup> </span><input type="password"
                  [(ngModel)]="signUpData.inviteCode" class="form-input" required />
              </div>
              <div class="input">
                <div class="submitButton">
                  <div class="button" (click)="submit();">
                    {{'SIGNUP.start' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #openVideos>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'SIGNUP.sign_up' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px"><iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen
            allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
      </div>
    </div>
  </div>

</ng-template>